var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconLoginGrey = function IconLoginGrey(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.825 7.175C43.77 2.015 35.886.054 28 0 20.115.054 12.231 2.015 7.175 7.175 2.015 12.23.054 20.115 0 28c.054 7.885 2.015 15.77 7.175 20.825C12.23 53.986 20.115 55.947 28 56c7.885-.053 15.769-2.014 20.825-7.175C53.986 43.77 55.947 35.886 56 28c-.053-7.885-2.015-15.77-7.175-20.825z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 44.469a21.431 21.431 0 01-2.649 3.524c-5.16 5.759-13.204 7.947-21.25 8.007-8.046-.06-16.091-2.248-21.25-8.007A21.612 21.612 0 014 44.129C9.188 42.237 17.807 41 27.561 41c10.327 0 19.38 1.387 24.439 3.469zM40 25c0 6.627-5.373 12-12 12-6.629 0-12-5.373-12-12s5.371-12 12-12c6.627 0 12 5.373 12 12z",
    fill: "#9A9999"
  }));
};

IconLoginGrey.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconLoginGrey;
//# sourceMappingURL=IconLoginGrey.js.map